var selector = { exports: {} };
export {
  selector as __module
};
//# sourceMappingURL=selector.js.map
